import React, { useState, useEffect } from 'react';
import { AbsoluteCenter, HSKLabel } from 'components/utility/General';
import { Flex, Center } from 'components/base/General';
import { LinearGradient } from 'tamagui/linear-gradient';
import { Stack, SizableText, View, ScrollView, Heading, XStack, YStack, useTheme, useThemeName } from 'tamagui';
import { HeaderText } from 'components/utility/General';
import { Platform, Dimensions } from 'react-native';
import { wrapImgCDN, wait } from 'utils/misc';
import loadable from '@loadable/component';
const Image = loadable(() => import('components/utility/CrossPlatformImage'), {
  ssr: false
});

// TODO make it slightly off center, a bit above center of image
export const DetailHeader = props => {
  return /*#__PURE__*/React.createElement(Flex, {
    height: 300,
    alignSelf: "flex-start",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Image, {
    resizeMode: "cover",
    flexGrow: 1,
    alignSelf: "flex-start",
    width: Dimensions.get('window').width,
    source: {
      uri: wrapImgCDN(props.article.image, Dimensions.get('window').width)
    }
    //w="100%"
  }), /*#__PURE__*/React.createElement(LinearGradient, {
    colors: ['transparent', 'rgba(0,0,0,1)'],
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      height: '100%'
    }
  }), /*#__PURE__*/React.createElement(AbsoluteCenter, null, /*#__PURE__*/React.createElement(DetailTitle, props), /*#__PURE__*/React.createElement(DetailDate, props), /*#__PURE__*/React.createElement(HSKLabel, {
    article: props.article,
    perLanguage: props.perLanguage
  })));
};

// TODO more general title?
const DetailTitle = props => {
  return /*#__PURE__*/React.createElement(Center, {
    px: 40
  }, /*#__PURE__*/React.createElement(HeaderText, {
    mx: 10,
    fontSize: "$2xl",
    $sm: {
      fontSize: '$3xl'
    },
    $md: {
      fontSize: '$4xl'
    },
    $lg: {
      width: '70%'
    },
    $xl: {
      fontSize: '$5xl'
    },
    textAlign: "center",
    color: "white",
    fontWeight: "bold",
    style: {
      userSelect: Platform.OS === 'web' ? 'none' : null
    },
    adjustsFontSizeToFit: true
  }, props.article.title));
};
const DetailDate = props => {
  return /*#__PURE__*/React.createElement(Heading, {
    textAlign: "center",
    color: "white",
    fontSize: "$xs",
    fontWeight: "bold",
    py: 20,
    style: {
      userSelect: Platform.OS === 'web' ? 'none' : null
    }
  }, props.article.date);
};